import { render, staticRenderFns } from "./transaction-vs-journal.vue?vue&type=template&id=02559254&scoped=true"
import script from "./transaction-vs-journal.vue?vue&type=script&lang=js"
export * from "./transaction-vs-journal.vue?vue&type=script&lang=js"
import style0 from "./transaction-vs-journal.vue?vue&type=style&index=0&id=02559254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02559254",
  null
  
)

export default component.exports